import request from '../../utils/request';

// 获取商行列表
export async function listAll(params) {
  return request({ url: 'device/activationCode/list', params, headers: 'json' });
}
